// extracted by mini-css-extract-plugin
export default {"label":"RadionForm_label__65r9F","input":"RadionForm_input__xwzXs"};